import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { LoaderService } from 'src/app/core/helpers/loader.service';

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

@Component({
    selector: 'loyaltic-participate-with-email-and-receipt',
    templateUrl: './participate-with-email-and-receipt.component.html',
    styleUrls: ['./participate-with-email-and-receipt.component.scss'],
    standalone: false
})
export class ParticipateWithEmailAndReceiptComponent implements OnInit {

  showConfirmReceiptUploadPopUp = false;
  showAnimationPopUp = false;

  receipt: any = [];
  receipt1: any;
  receipt2: any;
  Quantity = 1;
  ReceiptName = '';
  Phone = '';
  IsAcceptTerms = false;
  IsPrivacyPolicy = false;
  IsUserAlreadyLoggedIn = false;
  receiptSrc: any = [];
  receiptNotApprovedData: any;
  userId = '';
  Email = '';
  LoginType = 'Email';
  culture = ''
  clicked = false;
  generiPopupKeysObj:any;
  showGenericPopup = false;
  showLargeFileError = false;
  isFacebookApp = false;


  @Output() receiptUploadSuccess = new EventEmitter<any>();

  constructor(private authService: AuthService, private coreService: CoreService,
    private toast: ToastrService, private translate: TranslateService, private loaderService: LoaderService,
    private router: Router,
    //private gtmService: GoogleTagManagerService,
    private gaService: GaService,
    private modalService: BsModalService,
    private dataService: DataServiceService) {
      this.culture = translate.getDefaultLang();
     }


  ngOnInit() {
    this.resetToken();
    this.isFacebookApp = this.dataService.isFacebookApp
    this.userId = this.authService.getUserId();
    if ( this.userId) {
      this.IsUserAlreadyLoggedIn = true;
      this.coreService.getEmailAndPhone(this.userId).then((response:any) =>{
        console.log('userr', response);
        this.Email = response.result.userName;
      })

      console.log('userr', this.Email);
    }

  }

  // ngAfterViewInit() {
  //   this.modalRef = this.modalService.show(this.confirmReceiptUploadRef, this.confirmPopupConfig);
  // }

  resetToken() {
    const tokenTime = this.authService.getTokenTime();
    if (tokenTime) {
      const differenceMs = +new Date().getTime() - +new Date(tokenTime).getTime();
      const sec = differenceMs / 1000;
      const hours = sec / 3600;
      if (hours > 24) { this.authService.resetTokens() }
    }
  }

  onReceiptSelect(event) {
    this.receipt1 = event.target.files[0];
    this.Quantity = event.target.files.length;
    this.receipt = event.target.files
    console.log("this.receipt-->", this.receipt)
    this.ReceiptName = this.receipt[0].name ;
    for(let i=1; i< this.receipt.length; i++){
      this.ReceiptName = this.ReceiptName + "," + this.receipt[i].name
    }
    if (event.target.files && event.target.files[0]) {
      this.clicked = false;

      for(let i=0; i< this.receipt.length; i++){
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]);
        reader.onload = (e: any) => {
        this.receiptSrc.push(e.target.result)
      };
      }
    }
  }

  readFile(fileEvent: HTMLInputEvent) {
    const file: File = fileEvent.target.files[0];
    // console.log('size', file.size);
    // console.log('type', file.type);

    //Allowing 10 mb file
    if(file.size > 10000000) {
      this.showLargeFileError = true;
    }
  }

  showAnimationPopup() {
    this.showAnimationPopUp = true;
    // this.modalRef = this.modalService.show(this.uploadAnimationRef, this.popupConfig);
  }

  onReceiptUpload(form) {
    const formData = new FormData();

    this.Quantity = this.receipt? 1:0
    localStorage.setItem('LoginType',this.LoginType)

      formData.append('LoginType', this.LoginType.toString())
      formData.append('Quantity', this.Quantity.toString());
      for  (var i =  0; i <  this.receipt.length; i++)  {
        formData.append("File",  this.receipt[i]);
      }
      formData.append('Value', this.Email);
      formData.append('HasOptedForMarkettingEmail', this.IsPrivacyPolicy ? 'true' : 'false');
      formData.append('Culture', this.translate.getDefaultLang());
      this.coreService.participate(formData).then((response: any) => {
        this.clicked = true;
        this.dataService.hideModal();
        // localStorage.setItem('emailUser', this.Email)
        // localStorage.getItem('surveyTaken')? localStorage.removeItem('surveyTaken'):''
        // this.modalRef.hide();
        const result = response.result;
        this.authService.setToken(result.token, result.id);

        if (response.result.isNewUser){
          // this.gaService.emitEvent('new_user', 'new_user');
          sessionStorage.setItem('session','true')
        } else if(sessionStorage.getItem('session') != 'true') {
          // this.gaService.emitEvent('returning_user', 'returning_user');
        }

        if(!response.result.isapproved && response.result.isLogoUpload) {
          this.generiPopupKeysObj = {
            headerKey : 'pop-invalid-img-header',
            bodyKey :  'pop-invalid-img-body'
          }
          this.showGenericPopup = true;
          return;
      }
        else if (!response.result.isapproved && response.result.recptPartitionKey && response.result.recptRowKey) {
          this.dataService.setReceiptNotApprovedData(response.result)
          this.showConfirmReceiptUploadPopUp = true;
          return;
        }
        if (response.result.isapproved) {
          // this.gaService.emitEvent('logo_upload', 'logo_upload');
        }
        form.submitted = false;
        this.resetForm();
        localStorage.setItem('isWithFlow', '1');
        localStorage.setItem('playType', '1');
        response.result.isIntermediatePlayPageEnabled ? this.router.navigate(['click-to-play']): this.router.navigate(['play']);
      }).catch((errorResponse: any) => {
        this.clicked = false;
        this.dataService.hideModal();
        // this.modalRef.hide();
        console.log('error', errorResponse);
      });
  }

  freshParticipation() {
    this.authService.resetTokens();
    this.router.navigate([this.router.url])
 }

  resetForm() {
    this.receipt = undefined;
    this.Phone = undefined;
    this.ReceiptName = undefined;
    this.IsAcceptTerms = false;
    this.IsPrivacyPolicy = false;
  }
}
